import React from "react";
import { useParams, Link } from "react-router-dom";
import { useAtomValue } from "jotai";
import { Empty, Card } from "antd";
import { AgencyPageLayout, FlexBox, dateRangeState , TextCommon} from "@esg/ui";
import { AgencyDateRangePicker } from "@esg/ui/agency/components/filters";
import { UsageAnalyticsContainer } from "./containers";
import { dayjs } from "@esg/shared";

const UsageBranchDetailPage: React.FC = () => {
  const { branchId } = useParams<{ branchId: string }>();
  const globalDateRange = useAtomValue(dateRangeState);

  const startTime = globalDateRange
    ? dayjs(globalDateRange[0]).format("YYYY-MM-DD")
    : dayjs().startOf("year").format("YYYY-MM-DD");
  const endTime = globalDateRange
    ? dayjs(globalDateRange[1]).format("YYYY-MM-DD")
    : dayjs().format("YYYY-MM-DD");

  if (!branchId) {
    return (
      <AgencyPageLayout pageTitle="Branch Subscription > Branch Analytics">
        <Empty description="No branch selected." />
      </AgencyPageLayout>
    );
  }

  const customBreadcrumbTitle = (
  <FlexBox direction="row" alignItems="center" gap={4}>
    <Link to=".." title="Back to Directory">
      <TextCommon color="#262626"> 
        Branch Subscription 
      </TextCommon>
    </Link>
    <TextCommon color="#8c8c8c">{">"}</TextCommon>
    <TextCommon fontWeight={600} color="#1890ff">
      Branch Analytics
    </TextCommon>
  </FlexBox>
);

  return (
    <AgencyPageLayout
      pageTitle={customBreadcrumbTitle as any}
      RightExtraContent={
        <FlexBox
          direction="row"
          gap={12}
          alignItems="center"
          justifyContent="flex-end"
          width="100%"
        >
          <AgencyDateRangePicker />
        </FlexBox>
      }
    >
      <Card
        bordered={false}
        styles={{
          body: {
            padding: 0,
            maxHeight: "calc(100vh - 120px)",
            overflowY: "auto",
            overflowX: "hidden", 
            paddingBottom: "24px",
          },
        }}
        style={{ background: "transparent", width: "100%" }}
      >
        <FlexBox direction="column" width="100%" gap={24}>
          <UsageAnalyticsContainer
            branchId={branchId}
            startTime={startTime}
            endTime={endTime}
          />

        </FlexBox>
      </Card>
    </AgencyPageLayout>
  );
};

export { UsageBranchDetailPage };